import React, { Fragment } from "react";
import SafariIcon from "../assets/images/safari-icon.png";
import { GenErrorPageWithButton } from "../components/GenErrorPageWithButton";
import { Routes } from "../constants/Routing";
import "./CameraProblem.css";

export interface CameraProblemProps {
  uuid?: string;
  appId?: string;
  possiblyEmbedded: boolean;
  docType?: string;
}

export const CameraProblem: React.SFC<CameraProblemProps> = (props: CameraProblemProps) => {

  const { appId, possiblyEmbedded, uuid, docType } = props;

  const onContinuePress = () => {
    Routes.goToUploadManual(uuid, appId, docType);
  };

  const whatDoText = possiblyEmbedded ?
    (
      <Fragment>
        If you are accessing this page through a 3rd party window, please use your Safari browser app by
        clicking the Safari icon in the bottom right of your
        screen. <img className={"CameraProblem-safari-icon"} src={SafariIcon}/><br/><br/>
        Otherwise, please continue to the next page to upload your documents manually.
      </Fragment>
    ) :
    (
      <Fragment>
        It appears that your device does not support camera access for instant verification at this time. Please
        continue to the next page to upload your documents manually.
      </Fragment>
    );

  return (
    <GenErrorPageWithButton
      buttonTitle={"Continue"}
      title="Camera Access Not Supported"
      description={whatDoText}
      onButtonPress={onContinuePress}
    />
  );
};



// WEBPACK FOOTER //
// ./src/screens/CameraProblem.tsx